import React, { Component } from 'react';
import * as Config from './../config/Config';
import * as Common from './../helpers/Common';
import * as User from './../helpers/User';
import {
	handleCheckbox,
	handleRadio,
	handleSequence,
	autoFocusNext,
	allowOnlyNumberInput,
	countWords
} from '../helpers/Fields';

const $=window.$;

class Collaborate extends Component {
	constructor(props) {
		super(props);

        this.state={        	
        };
		this.getLrinfo=this.getLrinfo.bind(this);

	}	

	componentDidMount() {
		var text_max = 500;
		$('#balancedwords').html(text_max +'  '+'characters left');
		
		$('#txtcontes').keyup(function() {
			var text_length = $('#txtcontes').val().length;
			var text_remaining = text_max - text_length;
			if(text_remaining < 0)
			{
				$('#txtcontes').val('');
				
			}	
			$('#balancedwords').html(text_remaining+'  '+'characters left');
			
		});

		$('#collaborate-search').keyup(function() {
			var search_length = $('#collaborate-search').val().length;
			if(0 < search_length )
			{
				 //$('#sugglist').css("display", "block");
				 $('#sugglist').fadeIn(500);
			}
		});

		$("#erasetxt").click(function(){
			$('#txtcontes').val('');
			//$('#balancedwords').hide();
			$('#balancedwords').html(text_max +'  '+'characters left');
		});
		$("#drop-btn").click(function(){
			$('#txtcontes').val('');
			$('#max-char').html('500' +'  '+'characters left');
		});
		//Show Suggestion
		$('#suggetion-input').focusin(function(){
			$('.collaborate-active-cnt').fadeOut(500);
			$('.suggestion-box').fadeIn(500);
		});
		$('#srh-btn').click(function(){
			$('.suggestion-box').fadeIn(500);
		});
		$('.clear-btn').click(function(){
			$('.suggestion-box').fadeOut(500);
		});
		
		$('.hun-btn').focusin(function(){	
			$('.suggestion-box').fadeOut(500);
			$('.collaborate-active-cnt').fadeIn(500);
		});
		$('#hub-close').click(function(){
			$('.collaborate-active-cnt').fadeOut(500);
		});
		$('#sug-close').click(function(){
			$('#sugglist').fadeOut(500);
		})
		//arechive tab

		// $('.archives li').click(function(){
		// 	$(this).find('.fa').toggleClass('fa-plus fa-minus');
		// 	$(this).find('div').toggleClass('a-display');
		// });

		// $('.archives li').children('div').click(function(e){ e.stopPropagation();})

		$(document).ready(function($){
			$('.collaborate-active-cnt').css('display','none');
			var curr_lr="1328";
				$("#"+curr_lr).addClass('active-accordion');
			});
		
		$('.year li h4').click(function(){
			$(this).parent('li').siblings().removeClass('active');
			$(this).parent('li').siblings().find('.slide-cnt').slideUp();
			$(this).parent('li').toggleClass('active');
			$(this).parent('li').find('.slide-cnt').slideToggle();		
		});
		
		if($(window).width()>767)
		{
		  $('#collaborate-ul .cnt').slimscroll({  height: '250px',width: '110px'});
		}

	}

	getLrinfo(type,lr_id,dlr_id){
		this.props.switchPanel(type,lr_id,dlr_id);
	}

	
		render() {
						
		return (
			<section id="contentsection" className="contentarea radio-content">
        {/*Contentarea Starts*/}
        <div className="radio-title collaborate-title">
          <h2>Collaborate</h2>
          <p>Interact with your peers</p>
        </div>
        <div className="collaborate-body">       
          <div className="search-box">
            <input type="text" id="collaborate-search" className="collaborate-search" placeholder="Search..." />
            <button className="btn-search" />
          </div>
          <div className="collaborate-search-cnt" id="sugglist">
            <p className="suggestion-text">Search results for "testing", "digital marketing":</p>
            <ul className="suggestion-list">
              <li>
                <p className="que">Question by Ramon Prakash on March 15, 2018</p>
                <p className="ans">How can we <strong>test</strong> if <strong>digital marketing</strong> is effective?</p>
              </li>
              <li>
                <p className="que">Question by Sonia Popat on November 11, 2017</p>
                <p className="ans">Why is it that my <strong>digital marketing</strong> strategy works for some  products, but not so well for some other kind of products? </p>
              </li>
              <li>
                <p className="que">Comment by Martina Baker on October 5, 2015</p>
                <p className="ans">But my first <strong>digital marketing</strong>  attempt was a disaster. I got underconfident about my skill of understanding the digital sp. </p>
              </li>
              <li className="btn-container">
                <a className="btn btn-clear" id="sug-close" href="javascript:void(0);">Clear</a>
              </li>
            </ul>
          </div>
          <div className="activity-hub">
            <a href="javascript:void(0);" className="hun-btn">Activity Hub</a> <p><span>2</span> new questions, <span>0</span> new comments</p>
          </div>
          <div className="collaborate-active-cnt">
            <div className="left">
              <ul className="suggestion-list">
                <li>
                  <p className="que">Question by Ramon Prakash, 07:06:22 hrs, Mar 15, 2018<span className="red-new">New</span></p>
                  <p className="ans">How can we test if digital marketing is effective?</p>
                </li>
                <li>
                  <p className="que">Question by Sonia Popat on November 11, 2017<span className="red-new">New</span></p>
                  <p className="ans">Can anybody explain the meaning of "white labelling"? Some examples would be great.</p>
                </li>
                <li>
                  <p className="que">Comment by Arya Chaturvedi, 22:00:06 hrs, Jan 25, 2017</p>
                  <p className="ans">Democracy is followed in India. It has many flaws, but it is the best available form of governance. It may be...</p>
                </li>
                <li>
                  <p className="que">Question by Gopinathan C P, 11:25:00 hrs, May 3, 2016</p>
                  <p className="ans">Look at this image. It shows data on the scores of a group of students in 5 tests.  How to calculate the mode and median?</p>
                </li>				
              </ul>
            </div>
            <div className="right">
              <div className="year" id="collaborate-ul">
                <div className="cnt">
                  <ul>
                    <li className="active">
                      <h4>2018</h4>
                      <div className="slide-cnt" style={{display: 'block',marginTop: "-16px"}}>
                        <div className>
													<a href="javascript:void(0);">Dec</a>
													<a href="javascript:void(0);">Nov</a>
													<a href="javascript:void(0);">Oct</a>
													<a href="javascript:void(0);">Sept</a>
													<a href="javascript:void(0);">Aug</a>
													<a href="javascript:void(0);">Jul</a>
													<a href="javascript:void(0);">Jun</a>
													<a href="javascript:void(0);">May</a>
                          <a href="javascript:void(0);">Apr</a>
                          <a href="javascript:void(0);">Mar</a>
                          <a href="javascript:void(0);">Feb</a>
                          <a href="javascript:void(0);">Jan</a>
                        </div>
                      </div>
                    </li>
                    <li>
                      <h4>2017</h4>
                      <div className="slide-cnt">
                        <div className>
													<a href="javascript:void(0);">Dec</a>
													<a href="javascript:void(0);">Nov</a>
													<a href="javascript:void(0);">Oct</a>
													<a href="javascript:void(0);">Sept</a>
													<a href="javascript:void(0);">Aug</a>
													<a href="javascript:void(0);">Jul</a>
													<a href="javascript:void(0);">Jun</a>
													<a href="javascript:void(0);">May</a>
                          <a href="javascript:void(0);">Apr</a>
                          <a href="javascript:void(0);">Mar</a>
                          <a href="javascript:void(0);">Feb</a>
                          <a href="javascript:void(0);">Jan</a>
                        </div>
                      </div>
                    </li>
                    <li>
                      <h4>2016</h4>
                      <div className="slide-cnt">
                        <div className>
													<a href="javascript:void(0);">Dec</a>
													<a href="javascript:void(0);">Nov</a>
													<a href="javascript:void(0);">Oct</a>
													<a href="javascript:void(0);">Sept</a>
													<a href="javascript:void(0);">Aug</a>
													<a href="javascript:void(0);">Jul</a>
													<a href="javascript:void(0);">Jun</a>
													<a href="javascript:void(0);">May</a>
                          <a href="javascript:void(0);">Apr</a>
                          <a href="javascript:void(0);">Mar</a>
                          <a href="javascript:void(0);">Feb</a>
                          <a href="javascript:void(0);">Jan</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="clear" />
            <div className="btn-container">
              <a className="btn btn-clear" id="hub-close" href="javascript:void(0);">Close</a>
            </div>
          </div>
          <div className="have-questions">
            <h2>Have a question?</h2>
            <div className="emd">Embed a jpeg, mp4, mp3 file</div>
						
						<textarea  id="txtcontes" data-total-words="500" defaultValue={""} />
            <div className="btn-container">
              <div className="left" style={{marginleft: "-95px"}}>
							<span className="balance-words" id="balancedwords" style={{float:'left',color:"#1aa747"}}></span>
									<span className="typing-words" style={{visibility:'hidden'}} ></span>
              </div>
							{/* 							
							<div className="word-count" style={{margintop:'10px;',marginright: '-75px'}}>
									<span className="balance-words" style={{float:'right'}}></span>
									<span className="typing-words" style={{visibility:'hidden'}} ></span>
              </div> */}
              <div className="right">
                <a href="javascript:void(0);" className="btn btn-loud" id="erasetxt">Drop it</a>
                <a href="javascript:void(0);" className="btn btn-ask">Ask now</a>
              </div>
            </div>
          </div>
        </div>
      </section>
	  
		// <section id="contentsection" className="contentarea">
        //   <div className="inner-title-bg journey-tit-bg">
        //     <h1> <span> <img src={process.env.PUBLIC_URL+'/images/collb-img.jpg'} align="absmiddle" alt="Collaboration feature in i-meta" border="0" /> </span>Collaborate<br />
        //       <span className="subtitle">Interact with your peers</span></h1>
        //   </div>

        //   <div className="my-collabrate">

		// 				<section className="search">
		// 					<div className="">
		// 						<div className="input-container">
		// 							<form action="" method="">
		// 								<input type="text" name="search" id="suggetion-input" className="srh-txt" />
		// 								<button type="button" name="src-btn" className="srh-btn" id="srh-btn"><i className="fa fa-search"></i></button>
		// 							</form>
		// 						</div>
		// 						<div className="suggestion-box">
		// 							<p className="result">Search results for “testing”, “digital marketing”:</p>
		// 							<ul>
		// 								<li><span className="qus">Question by Ramon Prakash on March 15, 2018</span> How can we <strong>test</strong>  if <strong>digital marketing</strong> is effective?</li>
		// 								<li><span className="qus">Question by Sonia Popat on November 11, 2017</span> Why is it that my <strong>digital marketing</strong> strategy works for some<br/> products, but not so well for some other kind of products? </li>
		// 								<li><span className="qus">Comment by Martina Baker on October 5, 2015</span> ...but my <strong>first digital marketing </strong>attempt was a disaster. I got <br/>underconfident about my skill of understanding the digital sp...</li>
		// 							</ul>
									
		// 							<button className="clear-btn"> Clear</button>
		// 							<div className="clear"></div>
		// 						</div>
		// 						<div className="comment-area">
		// 							<a href="javascript:void(0);" className="hun-btn">Activity Hub</a> <span className="overview"><span style={{color: "#0070c0"}}>2</span> new questions, <span style={{color: "#0070c0"}}>0</span> new comments</span>
		// 							<div className="hub-container"> 
		// 								<div className="left">
		// 									<ul className="activity-detail">
		// 										<li><span className="qus">Question by Ramon Prakash, 07:06:22 hrs, Mar 15, 2018 <sup>New</sup></span> How can we test if digital marketing is effective?</li>
		// 										<li><span className="qus">Question by Ben Steven,18:15:06 hrs, Nov 11, 2017<sup>New</sup></span> Can anybody explain the meaning of “white labelling”? <br />Some examples would be great. </li>
		// 										<li><span className="qus">Comment by Arya Chaturvedi, 22:00:06 hrs, Jan 25, 2017</span> Democracy is followed in India. It has many flaws, but <br/>it is the best available form of governance. It may <br /> be…</li>
		// 										<li><span className="qus">Question by Gopinathan C P, 11:25:00 hrs, May 3, 2016</span>Look at this image. It shows data on the scores of a <br />group of students in 5 tests. How to calculate the <br />mode and median?</li>
		// 									</ul>
		// 								</div>
		// 								<div className="right">
		// 									<ul className="archives">
		// 										<li>2018
		// 											<div className="a-display">
		// 												<ul>
		// 													<li><a href="javascript:void(0);">Apr</a></li>
		// 													<li><a href="javascript:void(0);">Mar</a></li>
		// 													<li><a href="javascript:void(0);">Feb</a></li>
		// 													<li><a href="javascript:void(0);">Jan</a></li>
		// 												</ul>
		// 											</div>
		// 											{/* <span className="ctrl"><i className="fa fa-minus"></i></span> */}
		// 										</li>
		// 										<li>2017
		// 											<div>
		// 												<ul>
															
		// 													<li><a href="javascript:void(0);">Dec</a></li>
		// 													<li><a href="javascript:void(0);">Nov</a></li>
		// 													<li><a href="javascript:void(0);">Oct</a></li>
		// 													<li><a href="javascript:void(0);">Sep</a></li>
		// 													<li><a href="javascript:void(0);">Aug</a></li>
		// 													<li><a href="javascript:void(0);">Jul</a></li>
		// 													<li><a href="javascript:void(0);">Jun</a></li>
		// 													<li><a href="javascript:void(0);">May</a></li>
		// 													<li><a href="javascript:void(0);">Apr</a></li>
		// 													<li><a href="javascript:void(0);">Mar</a></li>
		// 													<li><a href="javascript:void(0);">Feb</a></li>
		// 													<li><a href="javascript:void(0);">Jan</a></li>
		// 												</ul>
		// 											</div>
		// 											{/* <span className="ctrl"><i className="fa fa-plus"></i></span> */}
		// 										</li>
		// 										<li>2016
		// 											<div>
		// 												<ul>
															
		// 													<li><a href="javascript:void(0);">Dec</a></li>
		// 													<li><a href="javascript:void(0);">Nov</a></li>
		// 													<li><a href="javascript:void(0);">Oct</a></li>
		// 													<li><a href="javascript:void(0);">Sep</a></li>
		// 													<li><a href="javascript:void(0);">Aug</a></li>
															
		// 												</ul>
		// 											</div>
		// 											{/* <span className="ctrl"><i className="fa fa-plus"></i></span> */}
		// 										</li>
		// 									</ul>
		// 								</div>
		// 								<div className="clear"></div>
		// 								<button className="clear-btn" id="hub-close"> Close</button>
		// 								<div className="clear"></div>
		// 							</div>
		// 							<div className="comment-box">
		// 								<div className="left">Have a question?</div>
		// 								<div className="right">Embed a jpeg, mp4, mp3 file</div>
		// 								<div className="clear"></div>
		// 								<form action="" method="">
		// 									<textarea className="que-box" id="que-box" maxLength="500"  placeholder="Enter your Question"></textarea>
		// 									<div className="max-char" id="max-char"></div>
		// 									<div className="comment-action">
		// 										<button type="button" className="drop" id="drop-btn">Drop it</button>
		// 										<button type="button" className="ask-btn"> Ask now</button>
		// 									</div>
		// 								</form>
		// 							</div>
		// 						</div>
								
		// 					</div>
		// 				</section>						
		// 				</div>         
        // </section>
			);
		}
}


export default Collaborate;




// WEBPACK FOOTER //
// ./src/group_interactions/Collaborate.js